import { render, staticRenderFns } from "./RallyRoundDefaultTeamlogoChooser.vue?vue&type=template&id=1681a708&"
import script from "./RallyRoundDefaultTeamlogoChooser.vue?vue&type=script&lang=ts&"
export * from "./RallyRoundDefaultTeamlogoChooser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports